import endpointNames from '../configs/serverUrls';
import axios from "axios";

const baseUrl = endpointNames.settings;
let token = JSON.parse(localStorage.getItem('token'));
const getTeams = async () => {
    let response;

    await axios.get(baseUrl.getTeams, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const addTeam = async (data) => {
    let response;

    await axios.post(baseUrl.addTeam, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const updateTeam = async (data) => {
    let response;

    await axios.put(baseUrl.updateTeam, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const getIndustries = async () => {
    let response;

    await axios.get(baseUrl.industries, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const getReasons = async () => {
    let response;

    await axios.get(baseUrl.getReasons, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const addReason = async (data) => {
    let response;

    await axios.post(baseUrl.addReason, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const deleteReason = async (id) => {
    let response;

    await axios.delete(baseUrl.deleteReason + id, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const addIndustry = async (data) => {
    let response;

    await axios.post(baseUrl.industries, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const updateIndustry = async (data) => {
    let response;

    await axios.put(baseUrl.industries + '/' + data.id, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const deleteIndustry = async (data) => {
    let response;

    await axios.delete(baseUrl.industries + '/' + data.id, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const getChannels = async () => {
    let response;

    await axios.get(baseUrl.getChannels, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const addChannel = async (data) => {
    let response;

    await axios.post(baseUrl.addChannel, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const updateChannel = async (data) => {
    let response;

    await axios.put(baseUrl.updateChannel, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const getPositions = async () => {
    let response;

    await axios.get(baseUrl.getPositions, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const addPosition = async (data) => {
    let response;

    await axios.post(baseUrl.addPosition, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const updatePosition = async (data) => {
    let response;

    await axios.put(baseUrl.updatePosition, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const getSettings = async () => {
    let response;

    await axios.get(baseUrl.settings, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const updateSettings = async (data) => {
    let response;

    await axios.put(baseUrl.settings, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const getPaymentMethods = async () => {
    let response;

    await axios.get(baseUrl.getPaymentMethods, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const addPaymentMethod = async (data) => {
    let response;

    await axios.post(baseUrl.addPaymentMethod, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

const updatePaymentMethod = async (data) => {
    let response;

    await axios.put(baseUrl.updatePaymentMethod, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error:- ", err);
            response = err;
        })

    return response;
}

export default {
    getTeams, addTeam, updateTeam,
    getChannels, addChannel, updateChannel,
    getPositions, addPosition, updatePosition,
    getSettings, updateSettings,
    getPaymentMethods,
    addPaymentMethod,
    updatePaymentMethod,
    getIndustries,
    updateIndustry,
    deleteIndustry,
    addIndustry,
    getReasons,
    addReason,
    deleteReason
}
